import Input from "@/components/Input";
import { SearchIcon } from "@/components/RFIcon";

interface Props {
	onChange: (val: string) => void;
	onClear: () => void;
	onClick?: () => void;
	value: string;
	placeholder: string;
}
export default function SearchInput(props: Props) {
	return (
		<div className="px-4 mb-4">
			<Input
				name="searchText"
				value={props.value}
				clearable
				onChange={props.onChange}
				onClear={props.onClear}
				aria-label={props.placeholder}
				placeholder={props.placeholder}
				id="search_text"
				leading={<SearchIcon className="c3_53_text mr-2 w-5 h-5" />}
				onClick={props.onClick}
			/>
		</div>
	);
}
